module.exports = "#define GLSLIFY 1\nattribute vec2 position;\nvarying vec2 v_position;\nvarying vec2 v_texcoord;\n\nvoid main() {\n  gl_Position = vec4(position, 0, 1);\n  v_position = position;\n  v_texcoord = position.xy * 0.5 + 0.5;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./shaders/main.vert
// module id = 40
// module chunks = 0